import styles from './style.module.css';
import { Typography } from '../../atoms';
import { ReactNode } from 'react';

type Props = {
  title: JSX.Element | string | (JSX.Element | string)[] | ReactNode;
  subTitle: JSX.Element | string | (JSX.Element | string)[] | ReactNode;
  subTitle2: JSX.Element | string | (JSX.Element | string)[] | ReactNode;
};

export const TitlesGroup = ({ title, subTitle, subTitle2 }: Props) => {
  return (
    <div className={styles.titleGroupContainer}>
      <Typography type="display">{title}</Typography>
      <Typography type="title2">{subTitle}</Typography>
      <Typography type="title2">{subTitle2}</Typography>
    </div>
  );
};
